import { cbi_extraction_type_enum } from '@predium/enums';
import { Trans, getI18n } from 'react-i18next';

export const translateCbiExtractionTypeEnum = (enumValue: cbi_extraction_type_enum) => {
  switch (enumValue) {
    case cbi_extraction_type_enum.ALPHA_PROMPT:
      return <Trans i18nKey="Enum_CbiExtractionTypeEnum-ALPHA_PROMPT" />;
    case cbi_extraction_type_enum.MANUAL:
      return <Trans i18nKey="Enum_CbiExtractionTypeEnum-MANUAL" />;
    case cbi_extraction_type_enum.PREDIUM:
      return <Trans i18nKey="Enum_CbiExtractionTypeEnum-PREDIUM" />;
  }
};

export const translateCbiExtractionTypeEnum_dynamic = (enumValue: cbi_extraction_type_enum) => {
  const t = getI18n().t;
  switch (enumValue) {
    case cbi_extraction_type_enum.ALPHA_PROMPT:
      return t('Enum_CbiExtractionTypeEnum-ALPHA_PROMPT');
    case cbi_extraction_type_enum.MANUAL:
      return t('Enum_CbiExtractionTypeEnum-MANUAL');
    case cbi_extraction_type_enum.PREDIUM:
      return t('Enum_CbiExtractionTypeEnum-PREDIUM');
  }
};
